import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ModalRoute from "./ModalRoute";

import CreateCampaignModal from "./Modals/CreateCampaignModal";
import CreateEmailModal from "./Modals/CreateEmailModal";
import CreateEmailTemplateModal from "./Modals/CreateEmailTemplateModal";
import CreateEmailModuleModal from "./Modals/CreateEmailModuleModal";

import SendEmailModal from "./Modals/SendEmailModal";
import SendEmailModuleModal from "./Modals/SendEmailModuleModal";
import CloneEmailModal from "./Modals/CloneEmailModal";
import CloneEmailModuleModal from "./Modals/CloneEmailModuleModal";
import CloneEmailTemplateModal from "./Modals/CloneEmailTemplateModal";

import DeleteEmailModal from "./Modals/DeleteEmailModal";
import DeleteEmailModuleModal from "./Modals/DeleteEmailModuleModal";
import DeleteEmailTemplateModal from "./Modals/DeleteEmailTemplateModal";
import DeleteImageModal from "./Modals/DeleteImageModal";
import DeleteCampaignModal from "./Modals/DeleteCampaignModal";

import ConfirmModal from "./Modals/ConfirmModal";

const routes = (
  <div>
    <ModalRoute path="create-campaign" component={CreateCampaignModal} />
    <ModalRoute path="create-email" component={CreateEmailModal} />
    <ModalRoute
      path="create-email-template"
      component={CreateEmailTemplateModal}
    />
    <ModalRoute path="create-email-module" component={CreateEmailModuleModal} />
    <ModalRoute path="send-email" component={SendEmailModal} />
    <ModalRoute path="send-email-module" component={SendEmailModuleModal} />
    <ModalRoute path="clone-email" component={CloneEmailModal} />
    <ModalRoute path="clone-email-module" component={CloneEmailModuleModal} />
    <ModalRoute
      path="clone-email-template"
      component={CloneEmailTemplateModal}
    />
    <ModalRoute path="delete-email" component={DeleteEmailModal} />
    <ModalRoute path="delete-email-module" component={DeleteEmailModuleModal} />
    <ModalRoute
      path="delete-email-template"
      component={DeleteEmailTemplateModal}
    />
    <ModalRoute path="delete-image" component={DeleteImageModal} />
    <ModalRoute path="delete-campaign" component={DeleteCampaignModal} />
    <ModalRoute path="confirm" component={ConfirmModal} />
  </div>
);

export class ModalRouter extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return routes;
  }
}

ModalRouter.propTypes = {};

// Connect state data
function mapStateToProps(state) {
  return {};
}

// Connect actions
export default connect(mapStateToProps, {})(ModalRouter);
